import colors from 'assets/styles/colors';
import Quill, { Delta } from 'quill';

export const getQuillDiffHTML = (
  oldHtml = '',
  newHtml = '',
  current: boolean,
) => {
  const tmp1 = document.createElement('div');
  const tmp2 = document.createElement('div');
  tmp1.innerHTML = replaceInlineStyles(oldHtml);
  tmp2.innerHTML = replaceInlineStyles(newHtml);

  const q1 = new Quill(document.createElement('div'));
  const q2 = new Quill(document.createElement('div'));

  const oldDelta = q1.clipboard.convert({ html: tmp1.innerHTML });
  const newDelta = q2.clipboard.convert({ html: tmp2.innerHTML });

  const diff = oldDelta.diff(newDelta);

  const finalOps = diff.ops
    .map((op) => {
      // if no changes
      if (!op.insert && !op.delete) {
        op.attributes = {
          color: 'inherit',
          background: 'transparent',
        };
        return op;
      }

      // handle insert
      if (op.insert) {
        if (current) {
          return {
            insert: op.insert,
            attributes: {
              background: colors.green0,
              color: colors.FOREST_GREEN,
            },
          };
        }
        // !current: ignore inserting
        return null;
      }

      // handle remove
      if (op.delete) {
        if (!current) {
          return {
            retain: op.delete,
            attributes: {
              background: colors.red0,
              color: colors.ROCKIN_RED,
              'data-removed': true,
            },
          };
        }
        // current: ignore deleting
        return op;
      }

      return op;
    })
    .filter((op) => op !== null) as typeof diff.ops;

  const highlightedDiff = new Delta(finalOps);
  const resultDelta = oldDelta.compose(highlightedDiff);

  const container = document.createElement('div');
  const q = new Quill(container);
  q.setContents(resultDelta);

  return q.root.innerHTML;
};

export const replaceInlineStyles = (value: string) => {
  const replacements = [
    ['background-color:rgb(250, 250, 250)', 'background-color:transparent'],
    ['background-color:rgb(255, 255, 255)', 'background-color:transparent'],
    ['color:rgb(44, 37, 67)', `color:${colors.textColor}`],
  ];

  return replacements.reduce(
    (acc, [search, replace]) => acc.replaceAll(search, replace),
    value,
  );
};
